const getPatient = async ({ commit, rootGetters, dispatch }, { patientId }) => {
  try {
    const customer = rootGetters["customer/CUSTOMER"];
    const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
    
    let customer_id = customer.customer_id;
    if (customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }

    const data = {
      customer_id,
      pid: patientId,
    };

    const response = await window.axios.post(
      '/proxy/api/data/get-patient',
      data
    );

    if (response && response.data.success) {
      commit("SET_PATIENT", response.data.patient);
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch("notifications/setError", error.message, { root: true });
  }
};

export default getPatient;
